export const isValidSearch = (value?: string) => {
  const searchLengthMin = 3;
  return value ? value.length >= searchLengthMin : false;
};
